import { AppTag } from "src/models/appV2";
import { createEntityModel } from "src/store/models/entity/_shared";

export const AppTagEntityModel = createEntityModel<AppTag>();
